import { Box, Paper, Typography, useTheme } from "@mui/material";

// Legend Component
const Legend: React.FC = () => {
  const theme = useTheme();

  const legendItems = [
    {
      label: "Confirmed Booking",
      color: theme.palette.primary.main,
    },
    {
      label: "Pending Request",
      color: theme.palette.secondary.main,
    },
    {
      label: "Unavailable",
      color: "#f44336",
    },
    {
      label: "Available",
      color: "#66bb6a",
    },
    {
      label: "Today",
      color: theme.palette.primary.light,
    },
  ];

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Legend
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {legendItems.map((item) => (
          <Box
            key={item.label}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: item.color,
                borderRadius: 1,
              }}
            />
            <Typography variant="body2">{item.label}</Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default Legend;
